import type { ComplianceState } from '../../../shared/types';

const LABEL: Record<ComplianceState, string> = {
  pass: 'PASS',
  outstanding: 'OUT',
  unknown: '—',
};
const CLS: Record<ComplianceState, string> = {
  pass: 'qa-badge--pass',
  outstanding: 'qa-badge--out',
  unknown: 'qa-badge--mute',
};
const SR: Record<ComplianceState, string> = {
  pass: 'compliance passing',
  outstanding: 'compliance outstanding — action required',
  unknown: 'compliance status unknown',
};

export function ComplianceBadge({ state, label }: { state: ComplianceState; label?: string }) {
  return (
    <span className={`qa-badge ${CLS[state]}`} aria-label={`${label ?? ''} ${SR[state]}`}>
      {LABEL[state]}
    </span>
  );
}
